export const Colors = {
    primary: '#225675',
    secondaryDark: '#113B54',
    secondaryLight: '#5B97BB',
    light: '#EBF9FF',
    gray: '#ECECEC',
    white: '#FFFFFF'
}